export const SET_SENTENCE_MENU_LEVEL = 'SET_SENTENCE_MENU_LEVEL';

export const setSentenceMenuLevel = (level: number) => ({
  type: SET_SENTENCE_MENU_LEVEL,
  data: level,
});
